import { observable, action } from "mobx";
import {getByAtribute} from "../../../utils/formatar";
import qs from "query-string";

export default class TabelaFiltroStore {

    constructor(carregarTabela, history) {
        this.history = history;
        this.carregarTabela = carregarTabela;
    }

    filtrar = (path, filterValues) => {
        this.history.push({pathname: path, search: qs.stringify(_.pickBy(filterValues, _.identity))});
        this.carregarTabela();
    };
}
